export default __webpack_public_path__ + "static/media/male.ca70acc2.png";